module.exports = __webpack_public_path__ + "static/EmbedMod-02-fef8cb7fedcb867ab57408a7e020ca84.png";